import { render, staticRenderFns } from "./taskManagement.vue?vue&type=template&id=e35b721a&scoped=true&"
import script from "./taskManagement.vue?vue&type=script&lang=js&"
export * from "./taskManagement.vue?vue&type=script&lang=js&"
import style0 from "./taskManagement.vue?vue&type=style&index=0&id=e35b721a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35b721a",
  null
  
)

component.options.__file = "taskManagement.vue"
export default component.exports